module.exports = __webpack_public_path__ + "img/graphic.6c8d91a3.svg";